import "./App.css";
import { Routes, Route, Outlet } from "react-router-dom";

// GLOBAL PAGES
import LoginSelectionPage from "./Pages/LoginSections/LoginSections";
import SignInPage from "./Pages/Admin/Auth/Auth";
import HrLogin from "./Pages/Manager/Auth/Auth";

// ADMIN
import DashboardLayout from "./Pages/Dashboard/Dashboard";
import CreateOwner from "./Pages/Admin/CreateOwner/CreateOwner";
import OwnersList from "./Pages/Admin/ListOwners/ListOwners";
import ListStalls from "./Pages/Admin/ListOwerStalls/ListStalls";
import AddOutlet from "./Pages/Admin/StallFom/StallForm";
import AddItem from "./Pages/Admin/ItemsCreate/ItemCreate";
import CreateCategories from "./Pages/Admin/Category/Category";
import StallCategories from "./Pages/Admin/ListCategory/ListCategory";
import ItemsPage from "./Pages/Admin/ItemsList/ItemsList";
import OrderSuccess from "./Pages/FrontendPages/OrderSuccess/OrderSuccess";
import SalesReport from "./Pages/Admin/SalesReport/SalesReport";

// VENDOR
import Login from "./Pages/Vendor/Login/Login";
import Outlets from "./Pages/Vendor/Outlet/Outlet";
import VendorItems from "./Pages/Vendor/Items/Items";

// FRONTEND KIOSK UI
import FliplynSignInPage from "./Pages/FrontendPages/SignIn/Login";
import FliplynSplashPage from "./Pages/FrontendPages/SplashScreen/SplashScreen";
import Stalls from "./Pages/FrontendPages/StallsScreen/Stalls";
import MainMenuPage from "./Pages/FrontendPages/MainMenu/MainMenu";
import CartSummary from "./Pages/FrontendPages/Cart/Cart";
import Payment from "./Pages/FrontendPages/PaymentScreen/PaymentScreen";
import PaymentScreen from "./Pages/FrontendPages/QRScreen/QRScreen";
import ReceiptPage from "./Pages/FrontendPages/PaymentReceipt/PaymentReceipt";

// PROTECTED ROUTES
import AdminProtectedRoute from "./ProtectedRoutes/AdminProtectedRoute";
import KioskProtectedRoute from "./ProtectedRoutes/KisokProtectedRoute";

// CONTEXT PROVIDERS
import KioskAuthProvider from "./ContextAPI/KisokContext";
import { KanchiOMAuthProvider } from "./ContextAPI/KanchiKisok";
import { VendorAuthProvider } from "./ContextAPI/VendorAuthContext";
import UPIPaymentScreen from "./Pages/FrontendPages/UPIPaymentScreen/UPIPaymentScreen";

// KANCHI CAFE
import KanchiLanding from "./KanchiPages/LandingPage/LandingPage";
import GuestEntry from "./KanchiPages/GuestEntry/GuestEntry";
import MenuCategories from "./KanchiPages/MenuCategories/MenuCategories";
import SacredBasket from "./KanchiPages/SacredBasket/SacredBasket";
import OrderTracker from "./KanchiPages/KOTTracker/Main";
import { CartProvider } from "./KanchiPages/Context/CartContext";
import KanchiCategoriesUI from "./KanchiPages/Category/Category";
import KanchiSignIn from "./KanchiPages/Authentication/SignIn";
import KanchiItems from "./KanchiPages/Items/Items";
import CafeTablesQR from "./KanchiPages/KanchiTable/KanchiTable";
import ReportsPage from "./KanchiPages/ReportsPage/ReportsPage";
import OrderSummary from "./KanchiPages/SacredBasket/OrderSummary";
import KanchiOrderSuccess from "./KanchiPages/SacredBasket/OrderSuccess";

function App() {
  return (
    <KioskAuthProvider>

      <Routes>

        {/* ================= LOGIN PAGES ================= */}
        <Route path="/" element={<LoginSelectionPage />} />
        <Route path="/admin-login" element={<SignInPage />} />
        <Route path="/manager-login" element={<HrLogin />} />

        {/* ================= ADMIN PROTECTED ================= */}
        <Route
          path="/dashboard"
          element={
            <AdminProtectedRoute>
              <DashboardLayout />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/create-owner"
          element={
            <AdminProtectedRoute>
              <CreateOwner />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/list-owner"
          element={
            <AdminProtectedRoute>
              <OwnersList />
            </AdminProtectedRoute>
          }
        />
        {/* ================= ADMIN OPEN ================= */}
        <Route path="/list-items" element={<ItemsPage />} />
        <Route path="/list-category" element={<StallCategories />} />
        <Route path="/list-stalls" element={<ListStalls />} />
        <Route path="/add-outlet-form" element={<AddOutlet />} />
        <Route path="/create-item" element={<AddItem />} />
        <Route path="/add-category" element={<CreateCategories />} />
        <Route path="/sales-report/:ownerId" element={<SalesReport />} />

        {/* ================= VENDOR ================= */}
        <Route
          element={
            <VendorAuthProvider>
              <Outlet />
            </VendorAuthProvider>
          }
        >
          <Route path="/vendor-login" element={<Login />} />
          <Route path="/vendor-Outtlet" element={<Outlets />} />
          <Route path="/vendor-items" element={<VendorItems />} />
        </Route>

        {/* ================= KIOSK LOGIN ================= */}
        <Route path="/kisok-login" element={<FliplynSignInPage />} />

        {/* ================= KIOSK PROTECTED ================= */}
        <Route
          path="/user"
          element={
            <KioskProtectedRoute>
              <FliplynSplashPage />
            </KioskProtectedRoute>
          }
        />

        <Route
          path="/stalls-user"
          element={
            <KioskProtectedRoute>
              <Stalls />
            </KioskProtectedRoute>
          }
        />

        <Route
          path="/menu"
          element={
            <KioskProtectedRoute>
              <MainMenuPage />
            </KioskProtectedRoute>
          }
        />

        <Route
          path="/order-success"
          element={
            <KioskProtectedRoute>
              <OrderSuccess />
            </KioskProtectedRoute>
          }
        />

        <Route
          path="/cart-summary"
          element={
            <KioskProtectedRoute>
              <CartSummary />
            </KioskProtectedRoute>
          }
        />

        <Route
          path="/payment"
          element={
            <KioskProtectedRoute>
              <Payment />
            </KioskProtectedRoute>
          }
        />

        <Route
          path="/payment-screen"
          element={
            <KioskProtectedRoute>
              <PaymentScreen />
            </KioskProtectedRoute>
          }
        />

        <Route
          path="/receipt"
          element={
            <KioskProtectedRoute>
              <ReceiptPage />
            </KioskProtectedRoute>
          }
        />

        {/* ================= KANCHI CUSTOMER FLOW ================= */}
        <Route
          element={
            <CartProvider>
              <Outlet />
            </CartProvider>
          }
        >
          <Route path="/order/:token" element={<KanchiLanding />} />
          <Route path="/guest-entry" element={<GuestEntry />} />
          <Route path="/kanchi-menu" element={<MenuCategories />} />
          <Route path="/kanchi-cart" element={<SacredBasket />} />
        </Route>

        <Route path="/kanchi-category" element={<KanchiCategoriesUI />} />
        <Route path="/category/:categoryId" element={<KanchiItems />} />
        <Route path="/kanchi-qr" element={<CafeTablesQR />} />

        {/* ================= KANCHI OM AUTH ================= */}
        <Route
          element={
            <KanchiOMAuthProvider>
              <Outlet />
            </KanchiOMAuthProvider>
          }
        >
          <Route path="/upi-payment" element={<UPIPaymentScreen />} />
          <Route path="/kanchi-signin" element={<KanchiSignIn />} />
          <Route path="/order-tracker" element={<OrderTracker />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/kanchi-order-summary" element={<OrderSummary />} />
          <Route path="/kanchi-success" element={<KanchiOrderSuccess />} />
        </Route>

      </Routes>

    </KioskAuthProvider>
  );
}

export default App;